module.exports = __webpack_public_path__ + "static/regulations-4a592b347dd0c7f712cadd3830811a59.jpg";